import { Link } from 'react-router-dom';
import { PhoneIcon, MapPinIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline';
import useLeads from '../../hooks/useLeads';
import LeadForm from '../ui/LeadForm';

const Footer = () => {
  const {
    isLeadFormOpen,
    leadFormData,
    closeLeadForm,
    requestCallback
  } = useLeads();
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mr-3 p-1">
                <img 
                  src="/images/kazpolimerplast-logo.png" 
                  alt="KazPolimerPlast Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">ТОО «KazPolimerPlast»</h3>
                <p className="text-sm text-secondary-400">Основана в феврале 2010 года</p>
              </div>
            </div>
            <p className="text-secondary-300 mb-6 leading-relaxed">
              Компания специализируется на выпуске труб полиэтиленовых для систем 
              водоснабжения, канализации, газоснабжения. Производственная мощность 6000 тонн в год.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/kazpolimerplast?igsh=OHlpZWc0eHhleGo2" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary-800 rounded-lg flex items-center justify-center hover:bg-pink-600 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
              <a href="https://wa.me/77089071712" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-secondary-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Products */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Продукция</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/catalog/water" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="text-sm lg:text-base">Трубы для водоснабжения</span>
                </Link>
              </li>
              <li>
                <Link to="/catalog/sewer" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="text-sm lg:text-base">Трубы для канализации</span>
                </Link>
              </li>
              <li>
                <Link to="/catalog/gas" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="text-sm lg:text-base">Трубы для газоснабжения</span>
                </Link>
              </li>
              <li>
                <Link to="/catalog/coextruded" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="text-sm lg:text-base">Соэкструзионные трубы</span>
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Компания</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3"></span>
                  О компании
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3"></span>
                  Услуги
                </Link>
              </li>
              <li>
                <Link to="/certificates" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3"></span>
                  Сертификаты
                </Link>
              </li>
              <li>
                <Link to="/contacts" className="text-secondary-300 hover:text-accent-orange transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-400 rounded-full mr-3"></span>
                  Контакты
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contacts */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Контакты</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPinIcon className="h-5 w-5 text-primary-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-secondary-300">Республика Казахстан</p>
                  <p className="text-secondary-400 text-sm">г. Уральск, ул. Полевая 1Д, нежилое помещение 1</p>
                </div>
              </li>
              <li className="flex items-center">
                <PhoneIcon className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0" />
                <a href="tel:+77084931267" className="text-secondary-300 hover:text-accent-orange transition-colors">
                  +7 (708) 493-1267
                </a>
              </li>
              <li className="flex items-center">
                <EnvelopeIcon className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0" />
                <a href="mailto:info@kazpolimerplast.kz" className="text-secondary-300 hover:text-accent-orange transition-colors">
                  info@kazpolimerplast.kz
                </a>
              </li>
              <li className="flex items-start">
                <ClockIcon className="h-5 w-5 text-primary-400 mr-3 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-secondary-300">Пн-Пт: 9:00-18:00</p>
                  <p className="text-secondary-400 text-sm">Сб-Вс: выходной</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-secondary-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <p className="text-secondary-400 text-sm">
                &copy; {new Date().getFullYear()} ТОО «KazPolimerPlast». Все права защищены.
              </p>
              <div className="flex space-x-4">
                <Link to="/privacy" className="text-secondary-400 hover:text-accent-orange text-sm transition-colors">
                  Политика конфиденциальности
                </Link>
                <Link to="/terms" className="text-secondary-400 hover:text-accent-orange text-sm transition-colors">
                  Условия использования
                </Link>
              </div>
            </div>
            <div className="mt-4 md:mt-0">
              <button 
                onClick={requestCallback}
                className="bg-accent-orange text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors"
              >
                Заказать звонок
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Lead Form Modal */}
      <LeadForm
        isOpen={isLeadFormOpen}
        onClose={closeLeadForm}
        leadType={leadFormData.leadType}
        productName={leadFormData.productName}
        productId={leadFormData.productId}
        calculatedPrice={leadFormData.calculatedPrice}
      />
    </footer>
  );
};

export default Footer;